module.exports = __webpack_public_path__ + "img/zuijia_17.085ee9dc.png";